import { Button, Card, Container } from "react-bootstrap";
import { Rating } from "react-simple-star-rating";
import { useState } from "react";
import backupReviews from "../backup_reviews.json";

export interface Summary {
  reviewCount: number;
  averageRating: number;
}
export interface Review {
  key: string;
  name: string;
  title: string;
  message: string;
  rating: number;
  date: string;
  response: {
    title: string;
    message: string;
  };
}

const getRating = (review: typeof backupReviews[0]) => {
  return Number(
    review.reviewScoreWithDescription.value.substring(
      0,
      review.reviewScoreWithDescription.value.indexOf("/")
    )
  ) / 2;
};

const getReviews = (start: number, end: number) => {
  let reviews = [];
  for (let i = start; i < end; i++) {
    reviews.push(backupReviews[i]);
  }
  return reviews.filter((r) => getRating(r) > 3).map((r) => ({
    key: r.id,
    name: r.reviewAuthorAttribution?.text as string,
    title: r.title,
    message: r.text,
    rating: getRating(r),
    date: r.submissionTime.longDateFormat,
    response: {
      title: r.managementResponses[0]?.header.text.replace(
        "VrboOwner",
        "owner"
      ),
      message: r.managementResponses[0]?.response,
    },
  })) as Review[];
};

export default function Reviews() {
  const reviews = getReviews(0, backupReviews.length);
  const [displayedReviews, setDisplayedReviews] = useState<Review[]>(getReviews(0, 5));

  const summary = {
    count: reviews.length,
    rating: reviews.reduce((acc, review) => acc + review.rating, 0) / reviews.length,
  };

  return (
    <>
      <Container>
        <h1 style={{ margin: 0 }}>{summary.count} Reviews</h1>
        <div
          style={{
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          <div>
            <Rating
              initialValue={summary.rating as number}
              allowFraction={true}
              size={45}
              readonly
            />
          </div>
          <span style={{ fontSize: "1.5rem" }}>
            &#40;
            {(summary.rating as number).toFixed(1)}
            &#41;
          </span>
        </div>
        {displayedReviews.map((review) => (
          <Card
            key={review.key}
            style={{
              marginTop: "1rem",
              marginBottom: "1rem",
              borderStyle: "none",
              boxShadow: "0px 0px 16px 0px rgba(17, 17, 26, 0.08)",
            }}
          >
            <Card.Body>
              <Card.Title>
                <h4>
                  <b>{review.title || "Untitled"}</b>
                </h4>
                <Card.Subtitle>
                  <span style={{ fontSize: "0.85rem" }}>by {review.name}</span>
                </Card.Subtitle>
                <div>
                  <Rating
                    initialValue={review.rating}
                    allowFraction={true}
                    size={25}
                    readonly
                  />
                </div>
              </Card.Title>
              <Card.Text
                style={{
                  marginTop: "1rem",
                  marginBottom: "1rem",
                  textIndent: "0",
                  textAlign: "left",
                }}
              >
                {review.message}
              </Card.Text>
              <span style={{ fontSize: "0.85rem" }}>{review.date}</span>
              {review.response.title ? (
                <>
                  <hr />
                  <h4>
                    <b>{review.response.title}</b>
                  </h4>
                  {review.response.message}
                </>
              ) : null}
            </Card.Body>
          </Card>
        ))}
        <div style={{ textAlign: "center" }}>
          <Button
            hidden={displayedReviews.length === summary.count}
            onClick={() => {
              setDisplayedReviews((prev) => [
                ...prev,
                ...getReviews(
                  displayedReviews.length,
                  Math.min(displayedReviews.length + 5, summary.count)
                ),
              ]);
            }}
          >
            Show More
          </Button>
        </div>
      </Container>
    </>
  );
}
